export default {"src":"/_next/static/media/image 310.39c48ff2.svg","height":46,"width":49,"blurWidth":0,"blurHeight":0};